import { render, staticRenderFns } from "./BiometricAuthSettings.vue?vue&type=template&id=8ced3804"
import script from "./BiometricAuthSettings.vue?vue&type=script&lang=ts"
export * from "./BiometricAuthSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports